import axiosInstance from 'helpers/axiosInstance';

import { TreatPharmacy } from './TreatPharmacy.types';

export interface PharmacySearchResponse {
  nextPageToken: number;
  pharmacies: TreatPharmacy[];
  pharmaciesThisRequest: number;
  totalPharmacies: number;
}

export interface PharmacySearchParams {
  radius: number; // i.e. 5,
  zip: string; // i.e. '55408'
}

const pharmacySearch = (params: PharmacySearchParams) => {
  const url = '/treat/pharmacies';

  return axiosInstance
    .get<PharmacySearchResponse>(url, {
      params,
    })
    .then(r => r.data);
};

export default pharmacySearch;
